import * as React from "react"
import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDown } from "lucide-react"
import { cn } from "@/lib/utils"

const Accordion = AccordionPrimitive.Root

function AccordionItem({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item> & {
  ref?: React.Ref<React.ComponentRef<typeof AccordionPrimitive.Item>>
}) {
  return (
    <AccordionPrimitive.Item
      ref={ref}
      className={cn("border-b", className)}
      {...props}
    />
  )
}
AccordionItem.displayName = "AccordionItem"

function AccordionTrigger({
  className,
  children,
  hideChevron,
  chevronPosition = "end",
  noRotate,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
  hideChevron?: boolean
  chevronPosition?: "start" | "end"
  noRotate?: boolean
  ref?: React.Ref<React.ComponentRef<typeof AccordionPrimitive.Trigger>>
}) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        ref={ref}
        className={cn(
          "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
          className
        )}
        {...props}
      >
        {chevronPosition === "start" && !hideChevron && (
          <ChevronDown
            className={cn(
              "h-4 w-4 shrink-0 transition-transform duration-200",
              noRotate ? "" : "[&[data-state=open]]:rotate-180"
            )}
          />
        )}
        {children}
        {chevronPosition === "end" && !hideChevron && (
          <ChevronDown
            className={cn(
              "h-4 w-4 shrink-0 transition-transform duration-200",
              noRotate ? "" : "[&[data-state=open]]:rotate-180"
            )}
          />
        )}
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}
AccordionTrigger.displayName = "AccordionTrigger"

function AccordionContent({
  className,
  children,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content> & {
  ref?: React.Ref<React.ComponentRef<typeof AccordionPrimitive.Content>>
}) {
  return (
    <AccordionPrimitive.Content
      ref={ref}
      className={cn(
        "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        className
      )}
      {...props}
    >
      <div className="pb-4 pt-0">{children}</div>
    </AccordionPrimitive.Content>
  )
}
AccordionContent.displayName = "AccordionContent"

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }



// "use client";
//
// import * as React from "react";
// import * as AccordionPrimitive from "@radix-ui/react-accordion";
// import { cn } from "@/lib/utils";
// import { ChevronDownIcon } from "@radix-ui/react-icons";
//
// const Accordion = AccordionPrimitive.Root;
//
// const AccordionItem = React.forwardRef<
//   React.ComponentRef<typeof AccordionPrimitive.Item>,
//   React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
// >(({ className, ...props }, ref) => (
//   <AccordionPrimitive.Item
//     ref={ref}
//     className={cn("border-b", className)}
//     {...props}
//   />
// ));
// AccordionItem.displayName = "AccordionItem";
//
// // Custom type to add chevron prop
// interface AccordionTriggerProps
//   extends React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> {
//   hideChevron?: boolean;
//   noRotate?: boolean;
//   chevronPosition?: "start" | "end";
// }
//
// const AccordionTrigger = React.forwardRef<
//   React.ComponentRef<typeof AccordionPrimitive.Trigger>,
//   AccordionTriggerProps
// >(
//   (
//     { className, children, hideChevron, noRotate, chevronPosition, ...props },
//     ref,
//   ) => (
//     <AccordionPrimitive.Header className="flex">
//       <AccordionPrimitive.Trigger
//         ref={ref}
//         className={cn(
//           "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline text-left",
//           !noRotate && "[&[data-state=open]>svg]:rotate-180",
//           className,
//         )}
//         {...props}
//       >
//         {chevronPosition === "end" ? (
//           <>
//             {children}
//             {!hideChevron && (
//               <ChevronDownIcon className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" />
//             )}
//           </>
//         ) : (
//           <>
//             {!hideChevron && (
//               <ChevronDownIcon className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" />
//             )}
//             {children}
//           </>
//         )}
//       </AccordionPrimitive.Trigger>
//     </AccordionPrimitive.Header>
//   ),
// );
// AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
//
// const AccordionContent = React.forwardRef<
//   React.ComponentRef<typeof AccordionPrimitive.Content>,
//   React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
// >(({ className, children, ...props }, ref) => (
//   <AccordionPrimitive.Content
//     ref={ref}
//     className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
//     {...props}
//   >
//     <div className={cn("pb-4 pt-0", className)}>{children}</div>
//   </AccordionPrimitive.Content>
// ));
// AccordionContent.displayName = AccordionPrimitive.Content.displayName;
//
// export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };


// import * as React from "react"
// import * as AccordionPrimitive from "@radix-ui/react-accordion"
// import { ChevronDownIcon } from "lucide-react"
//
// import { cn } from "@/lib/utils"
//
// function Accordion({
//   ...props
// }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
//   return <AccordionPrimitive.Root data-slot="accordion" {...props} />
// }
//
// function AccordionItem({
//   className,
//   ...props
// }: React.ComponentProps<typeof AccordionPrimitive.Item>) {
//   return (
//     <AccordionPrimitive.Item
//       data-slot="accordion-item"
//       className={cn("border-b last:border-b-0", className)}
//       {...props}
//     />
//   )
// }
//
// function AccordionTrigger({
//   className,
//   children,
//   ...props
// }: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
//   return (
//     <AccordionPrimitive.Header className="flex">
//       <AccordionPrimitive.Trigger
//         data-slot="accordion-trigger"
//         className={cn(
//           "focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
//           className
//         )}
//         {...props}
//       >
//         {children}
//         <ChevronDownIcon className="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" />
//       </AccordionPrimitive.Trigger>
//     </AccordionPrimitive.Header>
//   )
// }
//
// function AccordionContent({
//   className,
//   children,
//   ...props
// }: React.ComponentProps<typeof AccordionPrimitive.Content>) {
//   return (
//     <AccordionPrimitive.Content
//       data-slot="accordion-content"
//       className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm"
//       {...props}
//     >
//       <div className={cn("pt-0 pb-4", className)}>{children}</div>
//     </AccordionPrimitive.Content>
//   )
// }
//
// export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
